import React, { useEffect,useState } from 'react'
import Image from '../../components/common/Image'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Notification from '../../components/common/Error/Notification'
import { addOrderSuccess } from '../../store/userSlice'
import { GetAdvertisement } from '../../api/advertisement'
import './services.scss';
import Carousel from '../../components/common/carousel'
import moment from 'moment'
const Services = () => {
    const [advertisements, setAdvertisements] = useState([])
    const OrderSuccess = useSelector(state=>state.user)?.OrderSuccess || null
    const info = useSelector(state=>state.user)?.info || null
    const Firm = useSelector(state=>state.user)?.Firm || null
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const service_list= [
        {id:"1",name:"拖吊"},
        {id:"2",name:"送水"},
        {id:"3",name:"送油"},
        {id:"4",name:"接電"},
        {id:"5",name:"更換備胎"},
        {id:"6",name:"調離坑洞或沙堆"},
    ]
    useEffect(()=>{
        // if(Firm){
           
        // }else{
        //     setAdvertisements([])
        // }
        GetAdvertisement(Firm?{Firm}:null).then(res=>{
            if(res?.statusCode ===200){
                setAdvertisements(res.result)
            }
        })

    },[Firm])
  return (
    <div className='container'>
        <h1>
        歡迎使用<br/>
        全鋒一鍵救援</h1>
        <div className='grid-gap-24'>
            {
                info ?(
                <button className='btn btn-outline btn-left-align'
                onClick={()=>navigate("/identity?key=2",{state:{history:'/services'}})}
                >
                    <Image src='/images/icons/tag.svg' 
                        style={{width:32, height:32}}
                    />
                    <div className="d-flex btn-info-block">
                        <div className="">
                            <p className="title">{info.offer_pnoname}</p>
                            {/* <p className="text">{info.bank}</p> */}
                            <p className="text">{moment(info.expired_date).format("YYYY 年 MM 月 DD 日")}</p>
                            <p className="text">{info.car_no}・限用</p>
                        </div>
                        <button>
                        <Image src="/images/icons/chevron_right.svg" />
                        </button>
                    </div>
                </button>):( 
                <button className='btn btn-outline btn-left-align'
                onClick={()=>navigate("/identity?key=1",{state:{history:'/services'}})}
                >
                <Image src='/images/icons/plus.svg' />
                <p>帶入優惠身份</p>
                
            </button>)
            }
            <h2>服務項目</h2>
            <div className='select_grid_block'>
                {
                    service_list.map(service=>(
                    <div className='block' key={service.id}
                    onClick={()=>navigate(`/add?service=${service.id}`)}
                    >
                        <Image src={`/images/services/${service.id}.svg`}/>
                        <p>{service.name}</p>
                    </div>))
                }
            </div>
            {
                advertisements.length ? (<Carousel data={advertisements} /> ):(<></>)
            }
        </div>
        {
            OrderSuccess&&(
                <Notification
                title='你的服務已送出' 
                description={
                    <p>媒合成立後將會收到案件進度簡訊，<br/> 請保持手機暢通留意安全。</p>
                } 
                onConfirm={()=> dispatch(addOrderSuccess(null))}
                />
            )
        }
    </div>
  

  )
}

export default Services